import { Action, combineReducers } from '@ngrx/store';

import * as GetPolicy from './getPolicy/reducer';
import * as PutPolicy from './putPolicy/reducer';
import * as PolicyActions from './actions/reducer';
import * as Difference from './difference/reducer';

export const featureKey = 'policy';

export interface PolicyState {
  [GetPolicy.featureKey]: GetPolicy.State;
  [PutPolicy.featureKey]: PutPolicy.State;
  [PolicyActions.featureKey]: PolicyActions.State;
  [Difference.featureKey]: Difference.State;
}

export interface State {
  [featureKey]: PolicyState;
}

export const reducers = {
  [GetPolicy.featureKey]: GetPolicy.reducer,
  [PutPolicy.featureKey]: PutPolicy.reducer,
  [PolicyActions.featureKey]: PolicyActions.reducer,
  [Difference.featureKey]: Difference.reducer,
};

export function combiner(state: PolicyState | undefined, action: Action) {
  return combineReducers(reducers)(state, action);
}
